import { type Err, ErrorCode, Role } from "@pentacode/core";
import type { LitElement } from "lit";
import { property } from "lit/decorators.js";
import { alert } from "../elements/alert-dialog";
import { app } from "../init";
import { restart } from "../lib/restart";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Constructor<T> = new (...args: any[]) => T;

export function ErrorHandling<B extends Constructor<LitElement>>(baseClass: B) {
    class ErrorHandling extends baseClass {
        @property({ type: Boolean })
        offline = false;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        constructor(...args: any[]) {
            super(...args);
            app.api.errorHandler = (err: Err | null) => this._requestHook(err);
        }

        private async _requestHook(err: Err | null) {
            this.offline = !!err && err.code === ErrorCode.FAILED_CONNECTION;

            if (err) {
                void this._handleError(err);
            }
        }

        private async _handleError(e: Err) {
            switch (e.code) {
                case ErrorCode.TERMS_NOT_ACCEPTED:
                    if (app.profile?.role !== Role.Owner) {
                        await alert(
                            "Der Besitzer des Unternehmens hat den Bearbeitungsvertrag noch nicht akzeptiert. Der Besitzer muss sich einloggen und akzeptieren, bevor Sie Pentacode weiter verwenden können.",
                            {
                                title: "Bearbeitungsvertrag noch nicht akzeptiert",
                            }
                        );
                        await app.logout();
                        restart();
                    }
                    break;
                case ErrorCode.OUTDATED_CLIENT:
                    this.dispatchEvent(new CustomEvent("outdated-client"));
                    break;
                case ErrorCode.INVALID_SESSION:
                case ErrorCode.SESSION_EXPIRED:
                    await alert("Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an!", {
                        title: "Sitzung Abgelaufen",
                    });
                    await app.logout();
                    restart();
                    break;
                default:
                    if (e.display) {
                        await alert(e.message, {
                            type: "warning",
                        });
                    }
            }
        }
    }

    return ErrorHandling;
}
